export const CANDIDATE_STATUS_OPTIONS = [
  "All",
  "Shortlisted",
  "Under Review",
  "Selected",
  "Rejected",
  "Blacklisted",
] as const;

export type CandidateStatusOption = (typeof CANDIDATE_STATUS_OPTIONS)[number];

export const DEPARTMENT_CHART_COLORS = [
  "bg-blue-500",
  "bg-green-500",
  "bg-yellow-500",
  "bg-purple-500",
  "bg-red-500",
] as const;
